import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '../../../config/axios.config';
import { API_ENDPOINTS } from '../../../shared/api-endpoints';
import { encryptInput } from '../../../shared/shared-functions';

interface inputType {
	UserName: string;
	PhoneNumber: string;
	Password: string;
	DeviceId: string;
	UserType: string;

	//   userAgent: string;
}

export const UserLoginApi: any = createAsyncThunk('UserLoginApiList', async (input: inputType) => {
	const { UserName, Password, DeviceId, PhoneNumber, UserType } = input;

	try {
		// const formData = new URLSearchParams();
		// if (UserName) {
		// 	formData.append('username', UserName);
		// 	formData.append('UserType', UserType);
		//   } else if (PhoneNumber) {
		// 	formData.append('PhoneNumber', PhoneNumber);
		// 	formData.append('UserType', UserType);
		//   }
		// formData.append('password', Password);
		// formData.append('DeviceId', DeviceId);

		const body = {
			"FLAG": 0,
			"UserType": UserType,
			"LOGINID": UserName ? UserName : PhoneNumber,
			"PASSWORD": Password,
			"COMPNAME": "PSSWEB-SRV",
			"COMPUSER": "IUSR",
			"COMPIPADDRESS": "192.168.1.1",
			"BROWSERNM": "Chrome",
			"BROWSERVER": 114,
			"IPS": "192.168.1.1",
			"ISDOMAINVALID": 0,
			"EMAIL": ""
		}

		const { data } = await API.post(API_ENDPOINTS.USER_LOGIN, body, {
			headers: {
				'x-original-forwarded-for': '::1',
				// 'user-agent': userAgent,
				'content-type': 'application/json'
				// 'content-type': 'application/x-www-form-urlencoded'
			}
		});
		// localStorage.setItem("authUser", JSON.stringify(data?.DATA?.[0]));

		return data;
	} catch (userLoginApiError: any) {
		return userLoginApiError?.response?.data;
	}
});

const userLoginApiSlice = createSlice({
	name: 'UserLoginApiList',
	initialState: {
		userLoginApiRes: [],
		userLoginApiLoad: false,
		userLoginApiError: ''
	},
	reducers: {
		reset: (state) => {
			state.userLoginApiRes = [];
			state.userLoginApiLoad = false;
			state.userLoginApiError = '';
		}
	},
	extraReducers: (builder) => {
		builder.addCase(UserLoginApi.fulfilled, (state, action: any) => {
			state.userLoginApiLoad = false;
			state.userLoginApiRes = action.payload;
			state.userLoginApiError = '';
		});

		builder.addCase(UserLoginApi.pending, (state) => {
			state.userLoginApiLoad = true;
		});

		builder.addCase(UserLoginApi.rejected, (state, action: any) => {
			state.userLoginApiLoad = false;
			state.userLoginApiRes = [];
			state.userLoginApiError = action.payload;
		});
	}
});

export const { reset: resetUserLoginApi } = userLoginApiSlice.actions;
export default userLoginApiSlice.reducer;
